import { Resource as l, API as u } from "@coveo/platform-client";
import { shouldMockBatchAnswer as s } from "../ShouldMockBatchAnswer.js";
import { createMockBatchAnswerListResponse as p, createMockEvaluationCreationResponse as n, createMockBatchAnswerGetResponse as h } from "./BatchAnswerEvaluations.mocks.js";
const o = 2e3, m = 10, r = class r extends l {
  list(e, t) {
    return s(t?.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i(
          p(e?.filter)(
            t?.nbOfMockEntry ?? m,
            e?.page
          )
        );
      }, o);
    }) : this.api.get(this.buildPath(`${r.baseUrl}`, e));
  }
  create(e, t) {
    return s(t?.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i(n());
      }, o);
    }) : this.api.post(r.baseUrl, e);
  }
  rename(e, t, i) {
    return s(i?.isMocking) ? new Promise((c) => {
      setTimeout(() => {
        c(n());
      }, o);
    }) : this.api.put(
      `${r.baseUrl}/${e.evaluationId}/name`,
      t
    );
  }
  delete(e, t) {
    return s(t?.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i();
      }, o);
    }) : this.api.delete(`${r.baseUrl}/${e.evaluationId}`);
  }
  get(e, t) {
    return s(t?.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i(h());
      }, o);
    }) : this.api.get(`${r.baseUrl}/${e.evaluationId}`);
  }
};
r.baseUrl = `/rest/organizations/${u.orgPlaceholder}/answer/v1/evaluations`;
let a = r;
export {
  a as EvaluationResource
};
//# sourceMappingURL=BatchAnswerEvaluations.resource.js.map
